var exports = {
  "Q": "ChannelDuplicateModal.module__content___T3dkZ1",
  "c": "ChannelDuplicateModal.module__helperText___T3dkZ1",
};

module.exports = exports;
